import { FC } from "react";
import { Flex, FlexProps, Text } from "@chakra-ui/react";

import { CaseDocumentModel } from "@shared/models";
import { CASE_DOCUMENT_INFO } from "@containers/Cases/constants";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

import CaseDocumentStatusBadge from "./CaseDocumentStatusBadge";

interface CaseDocumentCardFrameProps extends FlexProps {
  caseDocument: CaseDocumentModel;
  onChooseValues?: () => void;
}

const CaseDocumentCardFrame: FC<CaseDocumentCardFrameProps> = ({
  caseDocument,
  onChooseValues,
  children,
  ...props
}) => {
  const { title, cardLabel } = CASE_DOCUMENT_INFO[caseDocument.kind];

  return (
    <Flex
      direction="column"
      gap="10px"
      p="18px"
      borderRadius="10px"
      border="1px solid"
      borderColor="gray.200"
      {...props}
    >
      <Flex justify="space-between" align="flex-start" gap={2}>
        <Flex direction="column" gap="2px" minW={0}>
          <Text fontSize="15px" fontWeight={FONT_WEIGHT.HEAVY} color="brand.modalHeaderText">
            {title}
          </Text>
          <Text fontSize="12px" color="brand.emptyStateText">
            {cardLabel}
          </Text>
        </Flex>
        <CaseDocumentStatusBadge caseDocument={caseDocument} onChooseValues={onChooseValues} />
      </Flex>
      {children}
    </Flex>
  );
};

export default CaseDocumentCardFrame;
